import React from "react";
import { Button, Form } from "react-bootstrap";

export const RH_PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

/**
 * Pagination client ou serveur avec sélecteur du nombre de lignes.
 * @param {number} totalItems - Nombre total d'éléments (côté client ou serveur)
 * @param {boolean} serverMode - Si true, totalItems = total API ; page suivante si page*perPage < total
 */
const RhTablePagination = ({
  currentPage,
  totalItems = 0,
  perPage,
  onPageChange,
  onPerPageChange,
  pageSizeOptions = RH_PAGE_SIZE_OPTIONS,
  itemLabel = "éléments",
  showPageSizeSelector = true,
  serverMode = false,
}) => {
  const total = Math.max(0, Number(totalItems) || 0);
  const totalPages = Math.max(1, Math.ceil(total / perPage) || 1);
  const safePage = Math.min(Math.max(1, currentPage), totalPages);
  const start = total === 0 ? 0 : (safePage - 1) * perPage + 1;
  const end = Math.min(safePage * perPage, total);

  const canPrev = safePage > 1;
  const canNext = serverMode
    ? safePage * perPage < total
    : safePage < totalPages;

  const handlePerPage = (e) => {
    const next = Number(e.target.value);
    if (onPerPageChange) onPerPageChange(next);
  };

  return (
    <div className="rh-pagination">
      <div className="rh-pagination-meta">
        <span className="rh-pagination-info">
          {total > 0 ? (
            <>
              Affichage <strong>{start}</strong>–<strong>{end}</strong> sur <strong>{total}</strong>{" "}
              {itemLabel} — Page {safePage} / {totalPages}
            </>
          ) : (
            <>Aucun {itemLabel}</>
          )}
        </span>
        {showPageSizeSelector && onPerPageChange && (
          <label className="rh-pagesize-select">
            <span>Lignes</span>
            <Form.Select
              size="sm"
              value={perPage}
              onChange={handlePerPage}
              aria-label="Nombre de lignes par page"
            >
              {pageSizeOptions.map((n) => (
                <option key={n} value={n}>
                  {n}
                </option>
              ))}
            </Form.Select>
          </label>
        )}
      </div>
      <div className="rh-pagination-btns">
        <Button
          size="sm"
          variant="outline-secondary"
          disabled={!canPrev}
          onClick={() => onPageChange(Math.max(1, safePage - 1))}
        >
          Précédent
        </Button>
        <Button
          size="sm"
          variant="outline-secondary"
          disabled={!canNext}
          onClick={() => onPageChange(Math.min(totalPages, safePage + 1))}
        >
          Suivant
        </Button>
      </div>
    </div>
  );
};

export default RhTablePagination;
